var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification',{staticClass:"sb-notification--counter",attrs:{"visible":_vm.notificationRecent || (_vm.notificationSimilar && _vm.similarEnabled)}})}
var staticRenderFns = []

export { render, staticRenderFns }